import type { QualityReport } from '#shared/types';
import { SectionShell } from './SectionShell';
import {
  FlagsCard,
  HistogramCard,
  OutsideRangeTrendCard,
  QualityBreakdownCard,
  UncoveredCard,
} from './QualityCards';
import { dimensionLabel, isQualityEmpty } from './report.logic';
import { useAnalyticsFilters } from './useAnalyticsFilters';
import { useAnalyticsSection } from './useAnalyticsSection';

/**
 * How much of the lab's output falls outside its reference ranges.
 *
 * The screen's job is as much to show what it *cannot* say as what it can. The
 * "not judgeable" slice is given the same visual weight as the rest, because a
 * lab whose ranges cannot judge a third of its results has a catalogue problem
 * that a tidier-looking chart would hide.
 */
export function QualityPage() {
  const filters = useAnalyticsFilters('quality');
  const { data, loading, error } = useAnalyticsSection<QualityReport>('quality', filters);

  return (
    <SectionShell
      section="quality"
      filters={filters}
      data={data}
      loading={loading}
      error={error}
      metrics={data?.headline}
      empty={data !== undefined && isQualityEmpty(data)}
      emptyMessage="No released reports in this period, so there is nothing to judge."
    >
      {data?.flags && (
        <div className="c-an__grid">
          <FlagsCard flags={data.flags} />
          <OutsideRangeTrendCard series={data.series} />
          {data.uncovered.length > 0 && <UncoveredCard uncovered={data.uncovered} />}
          {data.histogram && data.histogram.n > 0 && <HistogramCard histogram={data.histogram} />}
          <QualityBreakdownCard label={dimensionLabel(data.by)} breakdown={data.breakdown} />
        </div>
      )}
    </SectionShell>
  );
}
